module.exports = __webpack_public_path__ + "assets/img/skyChart.247724dd.png";